import { Input } from "../../components/ui/input";
import { Search } from "lucide-react";

const EmployeeFilters = ({ searchTerm, onSearchChange }) => {
  return (
    <div className="relative flex-1 max-w-md">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
      <Input
        placeholder="Search employees..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10 input-field"
        data-testid="employee-search-input"
      />
    </div>
  );
};

export default EmployeeFilters;
